import { render, staticRenderFns } from "./RecshareImportMbrDlg.vue?vue&type=template&id=68b8a880&scoped=true"
import script from "./RecshareImportMbrDlg.vue?vue&type=script&lang=js"
export * from "./RecshareImportMbrDlg.vue?vue&type=script&lang=js"
import style0 from "./RecshareImportMbrDlg.vue?vue&type=style&index=0&id=68b8a880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b8a880",
  null
  
)

export default component.exports